import { styled } from '@mui/material';

export const Root = styled('div')(({ theme }) => ({
  width: '100%',
  '&:focus-visible': {
    outline: `2px solid ${theme.palette.primary[400]}`,
    outlineOffset: theme.spacing(0.5),
  },
}));
